var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"motion-container"},_vm._l((_vm.data),function(item,index){return _c('div',{key:item.title,class:{ 
                'motion-item':true,  
                'scaleOut': _vm.motionOpen && index === 0,
                'scaleIn' : _vm.motionOpen && index === 1
                },style:({
                transform:`translateY(${ index * 54}px) scale(${  1 - index/10 })`,
                backgroundImage:`url(${item.img})`,
                opacity: 1 - index/10 * 3,
                zIndex: 10 - index 
            })})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }